import { render, staticRenderFns } from "./TcKimlikGuncelleme.vue?vue&type=template&id=cf868e80&scoped=true"
import script from "./TcKimlikGuncelleme.vue?vue&type=script&lang=js"
export * from "./TcKimlikGuncelleme.vue?vue&type=script&lang=js"
import style0 from "./TcKimlikGuncelleme.vue?vue&type=style&index=0&id=cf868e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf868e80",
  null
  
)

export default component.exports